import { render, staticRenderFns } from "./BtnAtualizarInvestimento.vue?vue&type=template&id=c8ae770c&"
import script from "./BtnAtualizarInvestimento.vue?vue&type=script&lang=js&"
export * from "./BtnAtualizarInvestimento.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports